import React, { useEffect, useState } from 'react';
import { Input, Radio, Form, Select } from 'antd';
import * as SM from '../../../../../components/ModalCentralizado/style';
import * as S from './styles';
import { getRazoesReprovacao } from '../../../../../services/cadastroConsulta';

export function ModalRazaoReprovacao({
  open,
  setOpen,
  razoesReprovacao,
  setRazoesReprovacao,
  idConsulta,
  razaoEdit,
  indexEdit,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;

  const [listaRazoesReprovacao, setListaRazoesReprovacao] = useState();
  const [disableFields, setDisableFields] = useState(false);
  const CriarRazaoReprovacao = formValues => {
    const {
      idRazaoForm,
      tituloForm,
      observacaoForm,
      tipoRazaoReprovacaoForm,
    } = formValues;
    setRazoesReprovacao([
      ...razoesReprovacao,
      {
        idRazaoReprovacao: idRazaoForm ?? 0,
        idConsulta,
        razao: tituloForm,
        descricao: observacaoForm,
        idTipoReprovacao: tipoRazaoReprovacaoForm,
      },
    ]);
    setOpen(!open);
  };

  const UpdateRazaoReprovacao = razaoEdicao => {
    const updatedRazaoReprovacao = razoesReprovacao.map((razao, index) => {
      razao.edicao = true;
      if (index === indexEdit) {
        return { ...razao, ...razaoEdicao };
      }

      return razao;
    });

    setRazoesReprovacao(updatedRazaoReprovacao);
  };

  const EditarRazaoReprovacao = formValues => {
    const { tituloForm, observacaoForm, tipoRazaoReprovacaoForm } = formValues;
    let razaoEdicao = razoesReprovacao?.find(x => x === razaoEdit);
    razaoEdicao = {
      ...razaoEdicao,
      razao: tituloForm,
      descricao: observacaoForm,
      idTipoReprovacao: tipoRazaoReprovacaoForm,
    };
    UpdateRazaoReprovacao(razaoEdicao);
    setOpen(!open);
  };

  const InitialStateListaRazoes = async () => {
    const { data } = await getRazoesReprovacao();

    const initialState = data.filter(
      ({ idRazaoReprovacao }) =>
        !razoesReprovacao
          .map(x => x.idRazaoReprovacao)
          .includes(idRazaoReprovacao)
    );

    setListaRazoesReprovacao(initialState);
  };

  const SelectedListaRazoes = idRazao => {
    if (!idRazao) return;
    const razao = listaRazoesReprovacao.find(
      r => r.idRazaoReprovacao === idRazao
    );
    form.setFieldsValue({
      tituloForm: razao.razao,
      observacaoForm: razao.descricao,
      tipoRazaoReprovacaoForm: razao.idTipoReprovacao,
    });
    setDisableFields(true);
  };

  const OnClearListaRazoes = () => {
    form.setFieldsValue({
      tituloForm: null,
      observacaoForm: null,
      tipoRazaoReprovacaoForm: null,
    });
    setDisableFields(false);
  };

  useEffect(() => {
    form.resetFields();
    InitialStateListaRazoes();
    setDisableFields(false);
  }, [open]);
  return (
    <SM.ModalCentralizada
      centered
      open={open}
      onCancel={() => setOpen(!open)}
      footer={null}
      width="550px"
      height="445px"
      closable={false}
    >
      <S.StyledForm
        form={form}
        onFinish={values =>
          razaoEdit
            ? EditarRazaoReprovacao(values)
            : CriarRazaoReprovacao(values)
        }
      >
        <S.Row style={{ marginBottom: '22px' }}>
          <S.Title>Adicione a razão de reprovação</S.Title>
        </S.Row>
        <S.Row>
          <S.StyledForm.Item
            name="idRazaoForm"
            initialValue={razaoEdit?.idRazaoReprovacao}
          >
            <Select
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Selecione uma razão de reprovação"
              onChange={e => SelectedListaRazoes(e)}
              onClear={() => OnClearListaRazoes()}
              style={{ width: '360px' }}
            >
              {listaRazoesReprovacao?.map((razao, index) => (
                <Option key={index} value={razao?.idRazaoReprovacao || ''}>
                  {razao?.razao || ''}
                </Option>
              ))}
            </Select>
          </S.StyledForm.Item>
        </S.Row>
        <S.Row>
          <S.StyledText>
            O título servirá como referência interna do GR para este retorno
          </S.StyledText>
        </S.Row>
        <S.Row>
          <S.StyledForm.Item
            name="tituloForm"
            initialValue={razaoEdit?.razao}
            rules={[
              { required: true, message: 'O título deve ser informado.' },
            ]}
          >
            <Input
              style={{ width: '360px' }}
              placeholder="Digite aqui o título"
              disabled={disableFields}
            />
          </S.StyledForm.Item>
        </S.Row>
        <S.Row>
          <S.StyledText>
            Lembrete: o texto abaixo será enviado para o motorista.
          </S.StyledText>
        </S.Row>
        <S.Row>
          <S.StyledForm.Item
            name="observacaoForm"
            initialValue={razaoEdit?.descricao}
            rules={[
              { required: true, message: 'A observação deve ser informada.' },
            ]}
          >
            <S.StyledTextArea
              style={{ width: '360px', height: '115px' }}
              placeholder="Digite aqui a observação"
              maxLength={2000}
              showCount={true}
              autoSize={{ minRows: 5, maxRows: 5 }}
              disabled={disableFields}
            />
          </S.StyledForm.Item>
        </S.Row>
        <S.Row>
          <S.StyledForm.Item
            name="tipoRazaoReprovacaoForm"
            initialValue={razaoEdit?.idTipoReprovacao}
            rules={[
              {
                required: true,
                message: 'O tipo da razão de reprovação deve ser informado.',
              },
            ]}
          >
            <Radio.Group disabled={disableFields}>
              <SM.OptionRadio value={1}>Pendência</SM.OptionRadio>
              <SM.OptionRadio value={2}>Bloqueio</SM.OptionRadio>
            </Radio.Group>
          </S.StyledForm.Item>
        </S.Row>
        <S.Row>
          <SM.ButtonCancel
            onClick={() => setOpen(!open)}
            htmlType="button"
            size="large"
          >
            Cancelar
          </SM.ButtonCancel>
          <SM.ButtonCustom type="primary" htmlType="submit" size="large">
            Salvar
          </SM.ButtonCustom>
        </S.Row>
      </S.StyledForm>
    </SM.ModalCentralizada>
  );
}
